import type { HelpCenterUserContext } from './user-context';

export interface HelpCenterUserInfo {
  /** The host app's own primary user ID (web: hashId, quiz: quizUserId). Shown as CRM `user_id`. */
  id: string;
  email?: string;
  name?: string;
  context?: HelpCenterUserContext;
}

export type HelpCenterUserInfoMapper<TUser> = (
  user: TUser,
) => HelpCenterUserInfo;

export function createHelpCenterUserInfo<TUser>(
  user: TUser | null | undefined,
  mapper: HelpCenterUserInfoMapper<TUser>,
): HelpCenterUserInfo | undefined {
  if (!user) return undefined;
  return mapper(user);
}
